import React from 'react';

import LoaderSpinner, {
  LoaderSpinnerSize
} from 'widget/shared/ui/LoaderSpinner';

import styles from './SubmissionFormLoader.module.scss';

const SubmissionFormLoader: React.FC = () => (
  <div className={styles['loader']}>
    <LoaderSpinner centered size={LoaderSpinnerSize.m} />
  </div>
);

export default React.memo(SubmissionFormLoader);
